import { PaginationMetadata } from '../models/paged-response.model';

/**
 * Abstract class to manage common pagination state and logic.
 * List components should extend this class and implement the loadData() method.
 */
export abstract class PaginationBaseComponent {
  // Initial pagination state (Factorization #1)
  public pagination: PaginationMetadata = {
    page: 1,
    per_page: 10,
    total_items: 0,
    total_pages: 0,
    has_next: false, // Whether there are more pages to come.
    has_prev: false,
  };

  /**
   * CONTRACT POINT: This method MUST be implemented by the child component.
   * This is the function that makes the specific API call (e.g. SkillService.getSkills).
   */
  protected abstract loadData(): void;

  /**
   * Handles page change (Factorization #2)
   */
  public onPageChange(newPage: number): void {
    if (newPage > 0 && newPage <= this.pagination.total_pages) {
      this.pagination.page = newPage;
      this.loadData(); // Call the implemented method by the child component
    }
  }

  /**
   * Handles page size change (Factorization #3)
   */
  public onPageSizeChange(newSize: number): void {
    if (this.pagination.per_page !== newSize) {
      this.pagination.per_page = newSize;
      this.pagination.page = 1; // Mandatory reset
      this.loadData(); // Call the implemented method by the child component
    }
  }
}

